// @ts-check

import { candidateMask, conflictsFor } from "../engine/board.js";
import { maskDigits } from "../engine/constants.js";
import { indexToCellId } from "./capabilities.js";

export function visibleBoard(game, puzzle, settings) {
  const board = Uint8Array.from(game.values, Number);
  return Array.from({ length: 81 }, (_, cell) => {
    const value = game.values[cell];
    const given = puzzle.givens[cell] !== "0";
    const result = {
      id: indexToCellId(cell),
      row: Math.floor(cell / 9) + 1,
      column: (cell % 9) + 1,
      box:
        Math.floor(Math.floor(cell / 9) / 3) * 3 +
        Math.floor((cell % 9) / 3) +
        1,
      given,
      value: value === "0" ? null : Number(value),
      notes: maskDigits(game.notes[cell] ?? 0),
      conflicts: conflictsFor(board, cell).map(indexToCellId),
    };
    if (settings.checkAgainstSolution && !given && value !== "0")
      result.matches_checked_solution = value === puzzle.solution[cell];
    return result;
  });
}

export function candidatesForCell(game, puzzle, cell) {
  const board = Uint8Array.from(game.values, Number);
  const current = game.values[cell];
  const editable = puzzle.givens[cell] === "0";
  const compatible = new Set(maskDigits(candidateMask(board, cell)));
  return Array.from({ length: 9 }, (_, offset) => {
    const digit = offset + 1;
    const conflicts = [];
    for (let peer = 0; peer < 81; peer += 1) {
      if (peer !== cell && game.values[peer] === String(digit)) {
        const sameRow = Math.floor(peer / 9) === Math.floor(cell / 9);
        const sameColumn = peer % 9 === cell % 9;
        const sameBox =
          Math.floor(Math.floor(peer / 9) / 3) ===
            Math.floor(Math.floor(cell / 9) / 3) &&
          Math.floor((peer % 9) / 3) === Math.floor((cell % 9) / 3);
        if (sameRow || sameColumn || sameBox)
          conflicts.push(indexToCellId(peer));
      }
    }
    return {
      digit,
      structurally_accepted: editable && !game.completed_at && !game.paused,
      sudoku_compatible: current === "0" && compatible.has(digit),
      would_toggle_off: current === String(digit),
      conflict_cells: conflicts.sort(),
    };
  });
}
